"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useToggle = void 0;
const react_1 = require("react");
const useToggle = (initialState) => {
    const [status, setStatus] = (0, react_1.useState)(initialState);
    const toggle = (newStatus) => {
        if (newStatus !== undefined) {
            setStatus(newStatus);
        }
        else {
            setStatus(!status);
        }
    };
    return [status, toggle];
};
exports.useToggle = useToggle;
